const dataDocs = {
    aposentadosDemitidosDownload: [{ id: 10, label: 'Termo DAP para download' }],
    aposentadosDemitidosUpload: [
        { id: 11, label: 'Termo DAP assinado' },
        { id: 12, label: 'Cópia do processo de demissão' },
        { id: 13, label: 'Cópia do último holerite' },
        { id: 14, label: 'Comprovante de residência' },
        { id: 15, label: 'Carta de concessão de aposentadoria' },
    ],
};

export default dataDocs;
